import { render, staticRenderFns } from "./textViewer.vue?vue&type=template&id=10ea5345&"
import script from "./textViewer.vue?vue&type=script&lang=js&"
export * from "./textViewer.vue?vue&type=script&lang=js&"
import style0 from "./textViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports